import React, { useState } from 'react'
import { Card } from "antd";
import {
  BarChartOutlined,
  TrophyOutlined,
  ClockCircleOutlined,
  FundOutlined,
  ShoppingCartOutlined,
  FieldTimeOutlined,
  TeamOutlined,
  MenuOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import cx from "classnames";
import styles from "../styles/KpisUI.module.css";

const cardIcons = {
  1: <BarChartOutlined />,
  2: <TrophyOutlined />,
  3: <ClockCircleOutlined />,
  5: <FundOutlined />,
  6: <ShoppingCartOutlined />,
  7: <FieldTimeOutlined />,
  8: <TeamOutlined />,
};

const NavItems = ({activeCard, handleActiveCard}) => {
  const [expanded, setExpanded] = useState(false);
  
  const cards = [
      { key: 1, label: "RESUMEN" },
      { key: 2, label: "TOP PRODUCTOS" },
      { key: 3, label: "TIEMPOS PROMEDIOS" },
   /*    { key: 4, label: "PEDIDOS POR ZONA" }, */
      { key: 5, label: "RESUMEN DE TOTALES" },
      { key: 6, label: "PEDIDOS Y VENTAS" },
      { key: 7, label: "ORDENES POR HORA" },
      { key: 8, label: "REPORTE DE RECOMPRAS" },
    ];

  return (
    <div className={styles.navWrapper}>
      <div className={styles.mobileNavToggle} onClick={() => setExpanded(!expanded)}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <MenuOutlined style={{ color: 'var(--orange)' }} /> {activeCard.label}
        </span>
        {expanded ? <UpOutlined style={{ fontSize: '12px' }} /> : <DownOutlined style={{ fontSize: '12px' }} />}
      </div>
      <div className={cx(styles.cardsContainer, expanded && styles.expanded)}>
      {cards.map((card) => (
        <Card
          hoverable
          key={card.key}
          className={cx(styles.card, activeCard.key === card.key && styles.activeCard)}
          size="small"
          bordered
          onClick={() => {
            handleActiveCard(card);
            setExpanded(false);
          }}
        >
          <div className={styles.cardBody}>
          <span className={styles.cardIcon}>{cardIcons[card.key]}</span>
          <span className={styles.cardLabel}>{card.label}</span>
        </div>
        </Card>
      ))}
      </div>
    </div>
  )
}

export default NavItems